import axios from './axiosInstances/identityAxiosInstance';

// External integration config API surface.
// Routes assume apigw routing:
//   /myemployee/external-integration/* -> be-employee (admin CRUD + test)
//   /stark/sync/*                       -> stark (manual sync trigger)
// stark's APP_BASE_PATH is /api/v1/stark, so apigw must proxy /api/v1/stark/*
// to the stark service.

const externalIntegrationApi = {
  async getByClientId(clientId) {
    return axios.post('/myemployee/external-integration/GetByClientId', { clientId });
  },
  async upsert(payload) {
    return axios.post('/myemployee/external-integration/Upsert', payload);
  },
  async test(clientId, groupValue) {
    return axios.post(`/myemployee/external-integration/Test/${clientId}`, {
      groupValue,
    });
  },
  async getStatus(clientId) {
    return axios.post('/myemployee/external-integration/GetStatus', { clientId });
  },
  async getTargetFields() {
    return axios.post('/myemployee/external-integration/GetTargetFields');
  },
  async syncNow(clientId) {
    return axios.post(`/stark/sync/${clientId}`);
  },
  async syncOneGroup(clientId, value) {
    return axios.post(`/stark/sync/${clientId}/group/${encodeURIComponent(value)}`);
  },
};

export default externalIntegrationApi;
